import { render, staticRenderFns } from "./ConversationLastCsatNotes.vue?vue&type=template&id=65d3af8e&scoped=true&"
import script from "./ConversationLastCsatNotes.vue?vue&type=script&lang=js&"
export * from "./ConversationLastCsatNotes.vue?vue&type=script&lang=js&"
import style0 from "./ConversationLastCsatNotes.vue?vue&type=style&index=0&id=65d3af8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d3af8e",
  null
  
)

export default component.exports